export default __webpack_public_path__ + "static/SRF Carasweet 5SGF7704 - Product Specifications & Technical Data-f59074e3c167e4e0e3b301c989071ebf.pdf";